export default __webpack_public_path__ + "static/media/icone-face.1a022a51.svg";